define('SageDotCom/Components/AgnosticProductCard/AgnosticProductCardContainer',["jquery",
    "eventManager",
    "SageDotCom/Components/ProductCardAlignment",
    "SageDotCom/DataLayer/Events/product-card-detail",
    "SageDotCom/DataLayer/Events/DynamicProductModal",
    "SageDotCom/Utility/sanitizer",
    'visitorIdCookie'],
    function ($, eventManager, productCardAlignment, ProductCardDetailEvent, modalEvents, sanitizer) {
        function AgnosticProductCardContainer(
            scope
        ) {
            //start common variables
            const $scope = $(scope);

            //function for matching height
            //Go through things in a sensible order: sub elements, then their parents, then the over all cardX

            //For each thing, remove the current height value, then run match height

            const matchElementHeights = function () {
                if (!window.AdjustingAgnosticCards) {
                    window.AdjustingAgnosticCards = true;

                    //Header
                    $(".sage-agnostic-product-card-header").matchHeight({ byRow: true });

                    //Select box / anything above the main price line
                    $(".agnostic-product-card-pricing .non-button-section .above-price-section .selector-section:visible").css("height", "").matchHeight({ byRow: true });
                    $(".agnostic-product-card-pricing .non-button-section .above-price-section:visible").css("height", "").matchHeight({ byRow: true });

                    //Main price line
                    $(".agnostic-product-card-pricing .non-button-section .pricing-information:visible").css("height", "").matchHeight({ byRow: true });
                    //Promo box
                    $(".agnostic-product-card-pricing .non-button-section .sage-agnostic-product-card-promo:visible").css("height", "").matchHeight({ byRow: true });
                    //Add on toggle
                    $(".agnostic-product-card-pricing .non-button-section .sage-product-card-addon-alt:visible").css("height", "").matchHeight({ byRow: true });

                    //Everything except the buttons
                    $(".agnostic-product-card-pricing .non-button-section:visible").css("height", "").matchHeight({ byRow: true });

                    //Everything in total
                    $(".agnostic-product-card-pricing:visible").css("height", "").matchHeight({ byRow: true });

                    //Footer components
                    //Footer top section
                    $(".agnostic-product-card-footer-top:visible").css("height", "").matchHeight({ byRow: true });
                    //Footer bottom section
                    $(".agnostic-product-card-footer-bottom .main-footer-content:visible").css("height", "").matchHeight({ byRow: true });
                    $(".agnostic-product-card-footer-bottom:visible").css("height", "").matchHeight({ byRow: true });
                    
                    $(".sage-agnostic-product-card-container").css("height", "").matchHeight({ byRow: true });

                    window.AdjustingAgnosticCards = false;
                }
            }

            const deferredFunction = function() {
                clearTimeout(window.agnosticCardResizeTimeout);
                window.agnosticCardResizeTimeout = setTimeout(() => $.fn.matchHeight._update(), 50);
            }

            $(window).on("resize", deferredFunction);
            eventManager.subscribe("adjust-agnostic-cards", matchElementHeights);

            //Run the function
            matchElementHeights();
        }

        AgnosticProductCardContainer.init = (args) => {
            return args.IsEditorEditing === true
                ? null
                : new AgnosticProductCardContainer(
                    args.scope
            );
        };

        return AgnosticProductCardContainer;
    });

